"use client";

import { usePathname } from "next/navigation";
import { useEffect } from "react";

export function HomeScrollEffect() {
  const pathname = usePathname();
  const isHome = pathname === "/";

  useEffect(() => {
    const homePageContentElement = document.getElementById("home-page-content");

    if (!(homePageContentElement instanceof HTMLElement)) {
      return;
    }
    const container: HTMLElement = homePageContentElement;

    if (!isHome) {
      container.classList.remove("scrolled");
      return;
    }

    let isAnimationFrameQueued = false;

    function updateScrolledClass() {
      const hasScrolled = window.scrollY > 0;
      container.classList.toggle("scrolled", hasScrolled);
    }

    function onScroll() {
      if (!isAnimationFrameQueued) {
        requestAnimationFrame(() => {
          updateScrolledClass();
          isAnimationFrameQueued = false;
        });
        isAnimationFrameQueued = true;
      }
    }

    // 初始检查
    updateScrolledClass();

    // 监听滚动
    window.addEventListener("scroll", onScroll, { passive: true });

    return () => {
      window.removeEventListener("scroll", onScroll);
    };
  }, [isHome]);

  return null;
}
